import React from 'react';
import './style.css';

/**
 * Данные компонента "Карта".
 * @class
 * @param {Object} props        данные, пришедшие от родителя
 * @param {Object} props.map    данные карты
 * @param {Object} props.text   пояснение для карты
 * @memberof ArticlePage
 */
const Map = (props) => (
    <div>
        <h2 className="map-header">Как проехать?</h2>
        <div className="map-container">
            <div className="map">
                <iframe src="https://yandex.ru/map-widget/v1/?um=constructor%3AyJSFaaAd9S2nzRxe10UHAqWnLp7zl9qN&amp;source=constructor" width="100%" height="480" frameBorder="0" title="Карта" />
            </div>
            <div className="mc__map-text">
                <p dangerouslySetInnerHTML={{__html: props.text}} />
            </div>
        </div>
    </div>
)

export default Map;